import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getclient_evaluationHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "clientevaluation", ...action.payload }),
		);
		yield put({
			type: types.GET_CLIENT_EVALUATION_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_CLIENT_EVALUATION_ERROR,
			payload,
		});
	}
}

export function* getclient_evaluationWatcherSaga() {
	yield takeLatest(
		types.GET_CLIENT_EVALUATION_START,
		getclient_evaluationHandlerSaga,
	);
}

//create

//delete

function* deleteclient_evaluationHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("clientevaluation", action.payload),
		);
		yield put({
			type: types.DELETE_CLIENT_EVALUATION_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_CLIENT_EVALUATION_ERROR,
			payload,
		});
	}
}

export function* deleteclient_evaluationWatcherSaga() {
	yield takeLatest(
		types.DELETE_CLIENT_EVALUATION_START,
		deleteclient_evaluationHandlerSaga,
	);
}

//update
